<template>
  <div>
    <v-data-table
      hide-default-footer
      class="vf-table mt-2"
      :items="items"
      :headers="fields" >
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-data-footer
          :pagination="pagination"
          :options="options"
          @update:options="updateOptions" />
      </template>
      <template #item.date="row">
        {{ formatDate(row.value) }}
      </template>
      <template #item.age_avg="row">
        {{ formatAvg(row.value) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Moment from 'moment-timezone'
import { round } from 'lodash'

export default {
  name: 'DailyStats',
  components: {
  },
  props: {
    customerReport: {
      type: Object
    }
  },
  data: function () {
    return {
      currentPage: 1,
      rowsPerPage: 10,
      sortBy: null,
      sortDesc: false,
      pageOptions: [10, 20, 50, 100]
    }
  },
  computed: {
    /**
     * The total number of results for the table
     */
    totalRows () {
      return this.items.length
    },
    /**
     * The list of items to display in the table. Computed for now in case we wanna tweak the fields any
     */
    items () {
      return this.customerReport.route_assessment_metrics
    },
    /**
     * The fields of the table.
     */
    fields () {
      return [
        {
          value: 'date',
          text: this.$t('date'),
          sortable: true
        },
        {
          value: 'opened',
          text: this.$t('reports_ui.route_assessment_metrics_report.opened_violations'),
          sortable: true,
          class: 'text-center border-left'
        },
        {
          value: 'closed',
          text: this.$t('reports_ui.route_assessment_metrics_report.closed_violations'),
          sortable: true,
          class: 'text-center'
        },
        {
          value: 'outstanding',
          text: this.$t('reports_ui.route_assessment_metrics_report.outstanding_violations'),
          sortable: true,
          class: 'text-center'
        },
        {
          value: 'age_avg',
          text: this.$t('reports_ui.route_assessment_metrics_report.average_violation_age'),
          sortable: true,
          class: 'text-center'
        },
        {
          value: 'age_max',
          text: this.$t('reports_ui.route_assessment_metrics_report.max_violation_age'),
          sortable: true,
          class: 'text-center'
        },
        {
          value: 'assessed_late',
          text: this.$t('reports_ui.route_assessment_metrics_report.violations_assessed_late'),
          sortable: true,
          class: 'text-center'
        }
      ]
    },
    /**
     * @return number
     */
    from () {
      return (this.rowsPerPage * (this.currentPage - 1)) + 1
    },
    /**
     * @return number
     */
    to () {
      return this.rowsPerPage * this.currentPage
    }
  },
  methods: {
    formatDate (date) {
      return Moment(date).format('ll')
    },
    formatAvg (avg) {
      return round(avg, 1)
    },
    formatNumber (value) {
      return Number(value).toLocaleString()
    }
  }
}
</script>

<style scoped>

</style>
